"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// styles
//
const StyledLabel_1 = require("../StyledLabel");
const StyledInput_1 = require("../StyledInput");
const StyledPasswordIcon_1 = require("../StyledPasswordIcon");
const StyledInvalidFeedback_1 = require("../../../onboarding/OnboardingForm/StyledInvalidFeedback");
const PasswordInput = (props) => {
    const [passwordHidden, setPasswordHidden] = (0, react_1.useState)(true);
    function handleTogglePassword() {
        setPasswordHidden(!passwordHidden);
    }
    return (react_1.default.createElement("div", { className: 'row g-3' },
        react_1.default.createElement("div", { className: 'col-12 mb-3' },
            react_1.default.createElement(StyledLabel_1.StyledLabel, { className: 'form-label', htmlFor: props.id, 
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                spacing: props.spacing ? props.spacing : '0' }, props.label),
            react_1.default.createElement("div", { className: 'input-group input-group-merge mb-3' },
                react_1.default.createElement(StyledInput_1.StyledInput, { className: props.error ? 'form-control is-invalid' : 'form-control', id: props.id, onBlur: props.onBlur, onChange: props.onInputChange, type: passwordHidden ? 'password' : 'text' }),
                react_1.default.createElement(StyledPasswordIcon_1.StyledPasswordIcon, { className: 'input-group-text' },
                    react_1.default.createElement("span", { className: passwordHidden ? 'fe fe-eye' : 'fe fe-eye-off', onClick: handleTogglePassword })),
                props.error ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'invalid-feedback' }, props.error)) : null))));
};
PasswordInput.propTypes = {
    error: prop_types_1.default.string,
    id: prop_types_1.default.string,
    label: prop_types_1.default.string,
    onBlur: prop_types_1.default.func,
    onInputChange: prop_types_1.default.func,
    spacing: prop_types_1.default.string
};
exports.default = PasswordInput;
